import React, { createContext, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const LoggerContext = createContext();

/*
	@TODO: This isn't currently being used.
	INFO: From here
	- console log
	- send to external logging
	- hit an API
	- dispatch to notifications
*/

const LoggerContextProvider = ({ children }) => {
	const error = (message) => {
		// TODO: Do the error logging stuff here.
		console.error('[ERROR] - ', message);
	};

	const info = (message) => {
		// TODO: Do the info logging stuff here.
		console.log('[INFO] - ', message);
	};

	const warn = (message) => {
		// TODO: Do the warn logging stuff here.
		console.warn('[WARN] - ', message);
	};

	const value = useMemo(
		() => ({
			error,
			info,
			warn
		}),
		[error, info, warn]
	);

	return (
		<LoggerContext.Provider value={value}>{children}</LoggerContext.Provider>
	);
};

LoggerContextProvider.propTypes = {
	children: PropTypes.object
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export const LoggerProvider = connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(LoggerContextProvider));

export const useLogger = () => {
	return useContext(LoggerContext);
};
